<template>
  <SSection
    v-for="(item, index) in items"
    :key="index"
    :title="item.title"
    :has-separator="false"
  >
    <template #no-container>
      <SCardsTinyImages :items="item.cards" />
    </template>
  </SSection>
</template>
<script setup lang="ts">
import type { propsInterface as sCardsTinyImagesProps } from '~~/modules/design-system/sections/s-cards-tiny-images/s-cards-tiny-images.vue'

export interface itemInterface {
  title?: string
  cards: sCardsTinyImagesProps['items']
}
export interface propsInterface {
  items: itemInterface[]
}

defineProps<propsInterface>()
</script>
